//deps
import React, { memo } from "react";

//styles
import { ShimmerContainer, ShimmerContent, ShimmerBlock } from "./styles";

const TableReservationShimmer = () => {
    return (
        <ShimmerContainer>
            <ShimmerContent>
                <ShimmerBlock height={50} marginBottom={12}></ShimmerBlock>
                <ShimmerBlock height={190} marginBottom={28}></ShimmerBlock>
                <ShimmerBlock height={80} marginBottom={28}></ShimmerBlock>
                <ShimmerBlock height={190} marginBottom={28}></ShimmerBlock>
            </ShimmerContent>
        </ShimmerContainer>
    );
};

export default memo(TableReservationShimmer);
